import { render, staticRenderFns } from "./FormCreateOffer.vue?vue&type=template&id=f65b94f4"
import script from "./FormCreateOffer.vue?vue&type=script&lang=js"
export * from "./FormCreateOffer.vue?vue&type=script&lang=js"
import style0 from "./FormCreateOffer.vue?vue&type=style&index=0&id=f65b94f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports